<div class="fullsize-vbox" style="gap: 2px; flex: 1">
    <div class="layout-hbox top-toolbar" style="align-items: center; justify-content: space-between; border: 1px solid lightgray; border-radius: 2px; padding: 2px 5px;">
        <div class="layout-hbox" style="grid-gap: 2px;">
            <fluent-button class="small-width" appearance="subtle" (click)="onGridMenuClick($event)" title="More options">
                <i class="fal fa-ellipsis-v-alt"></i>
            </fluent-button>

            <fluent-button class="small-width" appearance="subtle" [disabled]="!canUndo()" (click)="undoStack.undo()" title="Undo">
                <i class="fal fa-undo"></i>
            </fluent-button>

            <fluent-button class="small-width" appearance="subtle" [disabled]="!canRedo()" (click)="undoStack.redo()" title="Redo">
                <i class="far fa-redo"></i>
            </fluent-button>

            <fluent-button class="small-width" [appearance]="gridFrozenColumnsActive() ? 'outline' : 'subtle'"
                           (click)="toggleTableColumnLock()" title="Toggle column lock">
                <i class="fal {{gridFrozenColumnsActive() ? 'fa-table-cells-column-unlock' : 'fa-table-cells-column-lock'}}"></i>
            </fluent-button>

            <!-- Filter button and tooltip to explicitly state the current filter attributes -->
            <fluent-button class="small-width" [appearance]="gridIsFiltered() ? 'outline' : 'subtle'"
                           (click)="clearGridFilters()" [disabled]="!gridIsFiltered()">
                <i id="app-account-filter-button"  class="{{gridIsFiltered() ? 'far' : 'fal'}} fa-filter-circle-xmark"></i>
            </fluent-button>
            <fluent-tooltip anchor="app-account-filter-button" positioning="after" [innerHTML]="gridFilterTooltip()">
            </fluent-tooltip>

            <fluent-button class="small-width" [appearance]="sortingIsActive() ? 'outline' : 'subtle'"
                           (click)="clearGridSorting()" title="Clear sorting">
                <i class="fal fa-arrow-down-a-z"></i>
            </fluent-button>

            <fluent-button class="small-width" [appearance]="commentPaneVisible() ? 'outline' : 'subtle'"
                           (click)="toggleCommentsPane()" title="View/hide comments">
                <i class="fal fa-comments"></i>
            </fluent-button>

            <div class="layout-hbox phase-group-visiblity-controls" style="gap: 5px">
                <fluent-field label-position="before">
                    <label slot="label">Tiering</label>
                    <fluent-checkbox slot="input" ngChkboxDefaultControl [(ngModel)]="colVisibleTiering"></fluent-checkbox>
                </fluent-field>
                <fluent-field label-position="before">
                    <label slot="label">Tracking</label>
                    <fluent-checkbox slot="input" ngChkboxDefaultControl [(ngModel)]="colVisibleTracking"></fluent-checkbox>
                </fluent-field>
                <fluent-field label-position="before">
                    <label slot="label">Output</label>
                    <fluent-checkbox slot="input" ngChkboxDefaultControl [(ngModel)]="colVisibleOutput"></fluent-checkbox>
                </fluent-field>
            </div>

            <fluent-anchor-button class="small-width" appearance="subtle" title="Help" href="/help/account-data-help.html" target="_blank">
                <i class="fal fa-circle-question"></i>
            </fluent-anchor-button>

        </div>

        <div class="layout-hbox" style="grid-gap: 10px;">
            @if(hasServerSideChanges()) {
                <span style="color: darkorange"><i class="far fa-sparkles"></i> New data on server!</span>
            }
            <fluent-button [disabled]="!hasServerSideChanges()" (click)="syncWithServerData()">
                <i class="far fa-cloud-download-alt"></i> Sync
            </fluent-button>
            <fluent-button (click)="onFetchFromAgora()"><i class="far fa-arrow-down-from-arc"></i> AGORA Fetch</fluent-button>
            <fluent-button (click)="onGridDownload()"><i class="far fa-file-export"></i> Excel Export</fluent-button>
        </div>
    </div>

    <!-- Main pane: this view shows the account data grid, an optionally, to the right, a comments pane -->
    <div class="fullsize-hbox" style="gap: 5px; align-items: stretch;">
        <!-- Grid pane -->
        <wj-flex-grid #grid (initialized)="onGridInitialized(grid, gridFilter)" appVisibilityObserver (visibilityChange)="onGridVisibilityChange($event)"
                      [showSelectedHeaders]="Wijmo.HeadersVisibility.All"
                      [showMarquee]="true" width="100%" height="100%"
                      [allowResizing]="Wijmo.AllowResizing.Both" [autoRowHeights]="false" [quickAutoSize]="false"
                      [headersVisibility]="Wijmo.HeadersVisibility.All" [selectionMode]="Wijmo.SelectionMode.MultiRange" [isReadOnly]="false"
                      [autoGenerateColumns]="false"
                      [cloneFrozenCells]="true"
                      [allowSorting]="Wijmo.AllowSorting.MultiColumn"
                      [allowPinning]="Wijmo.AllowPinning.None"
                      (click)="onGridClick(grid, $event)"
        >
            <wj-flex-grid-filter #gridFilter [defaultFilterMode]="Wijmo.FilterMode.SingleFilter"></wj-flex-grid-filter>
            <div #gridMenuBtn class="menu-host-no-dropdown-button"></div>
        </wj-flex-grid>

        <!-- Gutter for Split / Grid -->
        <div class="gutter-col" style="grid-column: 2;" [class.hidden]="!commentPaneVisible()"
             (mousedown)="onResizeCommentsPaneStart($event)" >
        </div>

        <!-- Comments pane -->
        <app-account-comments-pane class="comments-pane hidden"
                                   [class.hidden]="!commentPaneVisible()" [hidden]="!commentPaneVisible()"
                                   [accountsCv]="this.pfSegData.accountsCollectionView.value()"
                                   (onCellPaneCommentClicked)="onCellPaneCommentClick($event)"
        >
        </app-account-comments-pane>
    </div>

    <div class="layout-hbox" style="align-items: center; justify-content: flex-end; grid-gap: 10px;">
        <wj-flex-grid-search #gridSearch style="flex-grow: 1"
                             placeholder="Search key(s)"
                             [grid]="grid">
        </wj-flex-grid-search>
        <div style="white-space: nowrap">
            Showing {{AppFormat.formatInteger(visibleRowCount())}}
            of {{AppFormat.formatInteger(totalRowCount())}} items
        </div>
    </div>

</div>
